import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useRef, useState, useEffect, useContext, useMemo } from 'react';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import { focusGroupManagerHoc } from '@elliemae/ds-shared/FocusGroup';
import DSSearchBox from '@elliemae/ds-form/SearchBox';
import { PropTypes, describe } from 'react-desc';
import VirtualMenuList from '../VirtualMenuList.js';
import MenuContext from '../MenuContext.js';
import 'react-window';
import '../utils/useHeightByAmountOfItems.js';

var SearchBoxWrapper = aggregatedClasses('div')('menu-search-group', 'search-wrapper');
var NoOptionsWrapper = aggregatedClasses('div')('menu-search-group', 'no-options');

function SearchableGroup(_ref) {
  var children = _ref.children,
      _ref$amountItemsInWin = _ref.amountItemsInWindow,
      amountItemsInWindow = _ref$amountItemsInWin === void 0 ? 5 : _ref$amountItemsInWin,
      _ref$searchTerm = _ref.searchTerm,
      searchTermProp = _ref$searchTerm === void 0 ? '' : _ref$searchTerm,
      _ref$noOptionsText = _ref.noOptionsText,
      noOptionsText = _ref$noOptionsText === void 0 ? 'No options' : _ref$noOptionsText,
      height = _ref.height,
      width = _ref.width,
      _ref$focusOnOpen = _ref.focusOnOpen,
      focusOnOpen = _ref$focusOnOpen === void 0 ? false : _ref$focusOnOpen;
  var searchRef = useRef(null);

  var _useState = useState(searchTermProp),
      _useState2 = _slicedToArray(_useState, 2),
      searchTerm = _useState2[0],
      setSearchTerm = _useState2[1];

  useEffect(function () {
    if (searchRef.current) searchRef.current.focus();
  }, []);

  var _ref2 = useContext(MenuContext) || {},
      visible = _ref2.visible;

  useEffect(function () {
    if (focusOnOpen && visible) {
      setTimeout(function () {
        if (searchRef.current) searchRef.current.focus();
      }, 0);
    }
  }, [focusOnOpen, visible]);
  var filteredChildren = useMemo(function () {
    return children.filter(function (child) {
      return !searchTerm || child.props.label.toLowerCase().startsWith(searchTerm.toLowerCase());
    });
  }, [children, searchTerm]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchBoxWrapper, null, /*#__PURE__*/React.createElement(DSSearchBox, {
    innerRef: searchRef,
    onSearch: function onSearch(_ref3) {
      var value = _ref3.value;
      return setSearchTerm(value);
    },
    searchOnEnter: false,
    showIcon: false,
    value: searchTerm
  })), !filteredChildren.length && /*#__PURE__*/React.createElement(NoOptionsWrapper, null, noOptionsText), /*#__PURE__*/React.createElement(VirtualMenuList, {
    amountItemsInWindow: amountItemsInWindow,
    height: height,
    items: filteredChildren,
    width: width
  }));
}

var props = {
  /** The amount of items that are going to be rendered in the group */
  amountItemsInWindow: PropTypes.number.description('The amount of items that are going to be rendered in the group'),

  /** A search term */
  searchTerm: PropTypes.string.description('A search term'),

  /** Text to show when there's no options to show */
  noOptionsText: PropTypes.string.description("Text to show when there's no options to show"),

  /** array of children for search list */
  children: PropTypes.array.description('array of children for search list'),

  /** height for virtual list wrapper */
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).description('height for virtual list wrapper'),

  /** width for virtual list wrapper */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).description('width for virtual list wrapper'),

  /** weather to focus on searchable group on open */
  focusOnOpen: PropTypes.bool.description('weather to focus on searchable group on open')
};
SearchableGroup.propTypes = props;
var DSMenuSearchableGroupWithSchema = describe(SearchableGroup);
DSMenuSearchableGroupWithSchema.propTypes = props;
var SearchableGroup$1 = focusGroupManagerHoc(SearchableGroup);

export default SearchableGroup$1;
export { DSMenuSearchableGroupWithSchema };
//# sourceMappingURL=SearchableGroup.js.map
